import React from 'react';

import { Panel as RPPanel, PanelProps as RPPanelProps } from 'react-resizable-panels';

import cn from '~/utils/cn';

export interface ResizeablePanelProps extends Omit<RPPanelProps, 'className'> {
  children: React.ReactNode;
  className?: string;
}

export const ResizeablePanel: React.FC<ResizeablePanelProps> = ({ children, className = '', ...rest }) => {
  return (
    <RPPanel className={cn('flex h-full', className)} {...rest}>
      {children}
    </RPPanel>
  );
};

export default ResizeablePanel;
